import { Directive, forwardRef } from '@angular/core'
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms'

@Directive({
  selector: '[appDateDDMMYYStringValidate][ngModel],[appDateDDMMYYStringValidate][formControl],[appDateDDMMYYValidate][formControlName]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => DateDDMMYYStringValidator), multi: true }
  ]
})
export class DateDDMMYYStringValidator implements Validator {
  validate(control: AbstractControl) {
    const regexp = /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/

    if (!control.value || control.value == '' ) {

      return null
    }

    const match = control.value.match(regexp)

    if (match == null) {

        return  { invalidDateString: {message: 'Debe ingresar la fecha con formato correcto'}}
    } else {
      if ( !this.tryParseDate(control.value) ) {
        control.reset()

        return { invalidDateString: {message: 'Debe ingresar una fecha valida'}}
      }
    }

    return null
  }

  private tryParseDate(stringDateValue) {

    const dateParts = stringDateValue.split('/')

    const stringDate = +dateParts[2] + '/' + +dateParts[1] + '/' + +dateParts[0]
    return  isNaN(Date.parse(stringDate)) ? false : true
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-services/date-ddmmyy.validator.ts